import { render, staticRenderFns } from "./DropdownSubMenu.vue?vue&type=template&id=5438a97c&scoped=true&"
import script from "./DropdownSubMenu.vue?vue&type=script&lang=js&"
export * from "./DropdownSubMenu.vue?vue&type=script&lang=js&"
import style0 from "./DropdownSubMenu.vue?vue&type=style&index=0&id=5438a97c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5438a97c",
  null
  
)

export default component.exports